module.exports = __webpack_public_path__ + "static/media/buses-main_x0.5_shortened.da02cbfe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/buses-main_x0.5_shortened.gif
// module id = 521
// module chunks = 0